// extracted by mini-css-extract-plugin
export default {"title":"Fact_title__hXPWY","row":"Fact_row__pJQ8r","column":"Fact_column__QmnpH"};